webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(25),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Home__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        Home: __WEBPACK_IMPORTED_MODULE_0__components_Home___default.a
    }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'options-menu': __webpack_require__(19),
        'stream-menu': __webpack_require__(20),
        'tweet': __webpack_require__(22)
    },

    data: function data() {
        return {
            // Move all data values to vuex store eventually
            connectingStream: false,
            createdAt: '',
            filterString: '',
            language: null,
            mode: 'options',
            socket: null,
            statusList: [],
            streaming: false,
            trackString: ''
        };
    },


    computed: {
        filterArray: function filterArray() {
            var _this = this;

            return this.statusList.filter(function (status) {
                var displayText = status.displayText,
                    name = status.name,
                    screen_name = status.screen_name,
                    status_id = status.status_id;

                var keyword = _this.filterString.toLowerCase();

                if (displayText.toLowerCase().includes(keyword)) {
                    return status;
                } else if (name.toLowerCase().includes(keyword)) {
                    return status;
                } else if (screen_name.toLowerCase().includes(keyword)) {
                    return status;
                } else if (status_id.includes(keyword)) {
                    return status;
                }
            });
        },
        statusListLength: function statusListLength() {
            return this.statusList.length;
        }
    },

    methods: {
        changeMode: function changeMode(mode) {
            this.mode = mode;
        },
        formatStatusData: function formatStatusData(status) {
            this.statusList.push(status);
        },
        saveStreamSettings: function saveStreamSettings(options) {
            this.socket.emit('set-options', options);
            this.mode = 'stream';
        },
        setFilterString: function setFilterString(event) {
            this.filterString = event.target.value;
        },
        setLanguage: function setLanguage(language) {
            this.language = language;
        },
        setTrackString: function setTrackString(event) {
            this.trackString = event.target.value;
        },
        setStreamOptions: function setStreamOptions(options) {
            this.language = options.language;
            this.trackString = options.track;
            this.createdAt = options.createdAt;
        },
        startStream: function startStream() {
            // Clear list if user had a stream previously open
            this.statusList = [];
            this.socket.emit('start-stream');
        },
        stopStream: function stopStream() {
            this.socket.emit('stop-stream');
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        this.socket = io('https://stream-manager.herokuapp.com/');
        // this.socket = io('localhost:3000');

        this.socket.on('connect', function () {
            _this2.socket.emit('register-worker');
        });

        this.socket.on('stream-active', function (active) {
            _this2.streaming = active;

            // If a new client connects, and a stream is active, this will put them in the stream viewing mode
            if (_this2.mode === 'options' && _this2.streaming) {
                _this2.mode = 'stream';
            }
        });

        this.socket.on('stream-options', this.setStreamOptions);

        this.socket.on('received-status', function (data) {
            _this2.formatStatusData(data);
        });

        this.socket.on('stream-closed', function () {
            // Only execute the following code once. This may be firing for every socket connected to a room
            alert('The stream has closed, try to start a new one.');
        });

        this.socket.on('user-error', function (msg) {
            alert(msg);
        });

        this.socket.on('on-error', function (msg) {
            console.error(msg);
        });
    },
    beforeDestroy: function beforeDestroy() {
        // Disconnects the client socket when the component unmounts to avoid multiple sockets still being attached to the server and duplicating events.
        this.socket.disconnect();
    }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        language: { required: true },
        setLanguage: { required: true, type: Function },
        saveStreamSettings: { required: true, type: Function },
        setTrackString: { required: true, type: Function },
        trackString: { required: true, type: String }
    },

    data: function data() {
        return {
            languages: [{ name: 'All', value: '' }, { name: 'English', value: 'en' }, { name: 'Spanish', value: 'es' }, { name: 'French', value: 'fr' }]
        };
    },


    computed: {
        canSaveOptions: function canSaveOptions() {
            return this.language === null || !this.trackString ? false : true;
        },


        languageSelect: {
            get: function get(vm) {
                return vm.language;
            },
            set: function set(value) {
                this.setLanguage(value);
            }
        }
    },

    methods: {
        formatOptions: function formatOptions() {
            return {
                language: this.language,
                track: this.trackString
            };
        },
        saveOptions: function saveOptions() {
            if (!this.canSaveOptions) return;

            this.saveStreamSettings(this.formatOptions());
        }
    }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        connectingStream: { required: true, type: Boolean },
        createdAt: { required: true },
        filterArray: { required: true, type: Array },
        filterString: { required: true, type: String },
        language: { required: true },
        statusListLength: { required: true, type: Number },
        setFilterString: { required: true, type: Function },
        startStream: { required: true, type: Function },
        stopStream: { required: true, type: Function },
        streaming: { required: true, type: Boolean },
        trackString: { required: true, type: String }
    },

    components: {
        streamTimer: __webpack_require__(21)
    },

    data: function data() {
        return {
            totalSeconds: 0,
            streamInterval: null
        };
    },


    computed: {
        canStartStream: function canStartStream() {
            return this.connectingStream || this.streaming;
        }
    },

    methods: {
        getDurationDiff: function getDurationDiff() {
            // Calculate the time that has elapsed since the stream was created and the client connected to the stream
            this.totalSeconds = Math.floor((new Date() - new Date(this.createdAt)) / 1000);
        },
        startStreamHandler: function startStreamHandler() {
            this.startStream();
            this.startTimer();
        },
        startTimer: function startTimer() {
            var _this = this;

            this.streamInterval = setInterval(function () {
                return ++_this.totalSeconds;
            }, 1000);
        },
        stopStreamHandler: function stopStreamHandler() {
            this.stopStream();
            this.stopTimer();
        },
        stopTimer: function stopTimer() {
            this.totalSeconds = 0;
            clearInterval(this.streamInterval);
        }
    },

    mounted: function mounted() {
        // If a new user joins the stream, start the timer and update seconds.
        // TODO get the start time from the stream. For now each user will have a different start time
        if (this.streaming) {
            this.getDurationDiff();
            this.startTimer();
        }
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        totalSeconds: { required: true, type: Number }
    },

    computed: {
        duration: function duration() {
            var hours = Math.floor(this.totalSeconds / 3600);
            var minutes = Math.floor((this.totalSeconds - hours * 3600) / 60);
            var seconds = this.totalSeconds - (hours * 3600 + minutes * 60);

            var hoursString = hours > 9 ? hours : "0" + hours;
            var minutesString = minutes > 9 ? minutes : "0" + minutes;
            var secondsString = seconds > 9 ? seconds : "0" + seconds;

            return hoursString + ":" + minutesString + ":" + secondsString;
        }
    }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        status: { required: true, type: Object }
    }

    // Code to grab the url from the end of a tweet string
    // Just kidding, need to figure out another way, the http url can be in another section of the text, or there can be multiple, etc.
    // m.slice(m.indexOf('http'))
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_scss_bootstrap_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_scss_bootstrap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_scss_bootstrap_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_scss__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main_scss__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// Load bootstrap v4 scss and js


// Import local styles


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(23),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07c1b177",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(16)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(27),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8c588e94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(24),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f3118d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(28),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b8e4e386",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(26),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f3af709",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("Twitter Stream")]), _vm._v(" "), (_vm.mode === 'stream') ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.streaming
    },
    on: {
      "click": function($event) {
        _vm.changeMode('options')
      }
    }
  }, [_vm._v("Options Menu\n        ")]) : _vm._e()]), _vm._v(" "), _c('options-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'options'),
      expression: "mode === 'options'"
    }],
    attrs: {
      "language": _vm.language,
      "save-stream-settings": _vm.saveStreamSettings,
      "set-language": _vm.setLanguage,
      "set-track-string": _vm.setTrackString,
      "track-string": _vm.trackString
    }
  }), _vm._v(" "), (_vm.mode === 'stream') ? _c('stream-menu', {
    attrs: {
      "connecting-stream": _vm.connectingStream,
      "created-at": _vm.createdAt,
      "filter-array": _vm.filterArray,
      "filter-string": _vm.filterString,
      "language": _vm.language,
      "start-stream": _vm.startStream,
      "set-filter-string": _vm.setFilterString,
      "status-list-length": _vm.statusListLength,
      "stop-stream": _vm.stopStream,
      "streaming": _vm.streaming,
      "track-string": _vm.trackString
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'stream'),
      expression: "mode === 'stream'"
    }],
    staticClass: "tweet-container"
  }, _vm._l((_vm.filterArray), function(status, i) {
    return _c('tweet', {
      key: i,
      attrs: {
        "status": status
      }
    })
  })), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "container footer"
  }, [_c('p', [_vm._v("Built with Vue.js, Node.js and Socket.io by\n            "), _c('a', {
    attrs: {
      "href": "https://dominicserrano.com"
    }
  }, [_vm._v("Dominic Serrano")])])])
}]}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stream-container"
  }, [_c('div', {
    staticClass: "jumbotron flex-one mr-2"
  }, [_c('h4', [_vm._v("Stream Stats")]), _vm._v(" "), _c('p', [_vm._v("State: " + _vm._s((_vm.streaming) ? 'Streaming' : 'Not Streaming'))]), _vm._v(" "), _c('stream-timer', {
    attrs: {
      "total-seconds": _vm.totalSeconds
    }
  }), _vm._v(" "), _c('p', [_vm._v("Number of Tweets: " + _vm._s(_vm.statusListLength))]), _vm._v(" "), _c('p', [_vm._v("Language: " + _vm._s(_vm.language))]), _vm._v(" "), _c('p', [_vm._v("Track String: " + _vm._s(_vm.trackString))])], 1), _vm._v(" "), _c('div', {
    staticClass: "jumbotron flex-three"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.canStartStream
    },
    on: {
      "click": _vm.startStreamHandler
    }
  }, [_vm._v("Start Stream")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.streaming
    },
    on: {
      "click": _vm.stopStreamHandler
    }
  }, [_vm._v("Stop Stream")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center mt-4 filter-container"
  }, [_c('p', [_vm._v("Search by Name, Username or Tweet Text")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filter"
    },
    domProps: {
      "value": _vm.filterString
    },
    on: {
      "input": _vm.setFilterString
    }
  }), _vm._v(" "), (_vm.filterString) ? _c('p', [_vm._v(" Filter Results: " + _vm._s(_vm.filterArray.length))]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('home')], 1)
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tweet"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "profile-image",
    attrs: {
      "src": _vm.status.profile_image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-txt"
  }, [_c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.status.name))]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://twitter.com/" + (_vm.status.screen_name))
    }
  }, [_c('span', [_vm._v("@" + _vm._s(_vm.status.screen_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "display-text"
  }, [(_vm.status.reply_name) ? _c('p', {
    staticClass: "reply-text"
  }, [_vm._v("Replying to\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://twitter.com/" + (_vm.status.reply_name))
    }
  }, [_c('span', {
    staticClass: "reply-name",
    domProps: {
      "textContent": _vm._s(("@" + (_vm.status.reply_name)))
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.status.displayText))])]), _vm._v(" "), (_vm.status.media) ? [_c('div', {
    staticClass: "media-container"
  }, _vm._l((_vm.status.media), function(img, i) {
    return _c('img', {
      key: i,
      staticClass: "media-image",
      attrs: {
        "src": img.media_url
      }
    })
  }))] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h2', [_vm._v("About")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Currently only one stream can be created at a time due to the limitation of the Stream API, but multiple users can view the ongoing stream and it's details.")]), _vm._v(" "), _c('h4', [_vm._v("Select your stream options")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-6 col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "language"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.languageSelect),
      expression: "languageSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "language",
      "id": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.languageSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("---")]), _vm._v(" "), _vm._l((_vm.languages), function(l, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": l.value
      }
    }, [_vm._v(_vm._s(l.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-6 col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "track"
    }
  }, [_vm._v("Track")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "track",
      "id": "track",
      "placeholder": "Words or phrases to track"
    },
    domProps: {
      "value": _vm.trackString
    },
    on: {
      "input": _vm.setTrackString,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.saveOptions($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.canSaveOptions
    },
    on: {
      "click": _vm.saveOptions
    }
  }, [_vm._v("Save Settings")])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_vm._v("Twitter Stream is a full stack JavaScript application using the Twitter streaming API to filter custom tweets selected by a user. A user can filter tweets based on selected languages, certain words or phrases, hashtags, user accounts, locations and other options. Check out "), _c('a', {
    attrs: {
      "href": "https://twitter.com/search-advanced",
      "target": "_blank"
    }
  }, [_vm._v("Twitter's advanced search")]), _vm._v(" for a full example of these search parameters.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row marketing"
  }, [_c('h2', {
    staticClass: "col-lg-12"
  }, [_vm._v("About Stream Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('h4', [_vm._v("Track")]), _vm._v(" "), _c('p', [_vm._v("Keywords to track. Phrases of keywords are specified by a comma-separated list.")])])])
}]}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    Duration of Stream: " + _vm._s(_vm.duration) + "\n")])
},staticRenderFns: []}

/***/ })
],[11]);


// WEBPACK FOOTER //
// static/js/app.39aff775c7f3a8a6f004.js